var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentsIcon = function SvgPaymentsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentcolor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "payments_icon_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#payments_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.667 10.833a2.4 2.4 0 0 1-1.771-.729 2.4 2.4 0 0 1-.73-1.77q0-1.042.73-1.771a2.4 2.4 0 0 1 1.77-.73 2.4 2.4 0 0 1 1.771.73q.73.729.73 1.77 0 1.042-.73 1.771a2.4 2.4 0 0 1-1.77.73m-5.834 2.5q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.176V5q0-.687.49-1.177t1.177-.49H17.5q.687 0 1.177.49T19.167 5v6.667q0 .687-.49 1.177t-1.177.49zM7.5 11.667h8.333q0-.688.49-1.177T17.5 10V6.667q-.687 0-1.177-.49A1.6 1.6 0 0 1 15.833 5H7.5q0 .687-.49 1.177-.489.49-1.177.49V10q.688 0 1.177.49.49.489.49 1.177m8.333 5H2.5q-.687 0-1.177-.49A1.6 1.6 0 0 1 .833 15V6.667q0-.354.24-.594t.594-.24.593.24.24.594V15h13.333q.354 0 .594.24t.24.593-.24.594a.8.8 0 0 1-.594.24"
  }))));
};
export default SvgPaymentsIcon;